let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3E5q8")).then(() => parcelRequire('8OzPr'));